<template>
    <dialog-modal v-if="shouldRender" :show="show" @close="closeModal">
        <template #title>
            <div>
                {{ trans('assets.modal.operable_blocked.title') }}
            </div>
        </template>

        <p class="mb-3">{{ trans('assets.modal.operable_blocked.description') }}</p>

        <ul class="list-disc space-y-1 pl-4">
            <li v-for="workOrder in workOrders" :key="workOrder.id">
                <b>{{ workOrder.code }}</b>
                <span v-if="workOrder.title"> — {{ workOrder.title }}</span>
                <span class="text-muted"> ({{ workOrder.status?.label }})</span>
            </li>
        </ul>

        <template #footer>
            <jet-button type="button" variant="primary" style="flex: 1" @click.stop="closeModal">
                {{ trans('general.action.close') }}
            </jet-button>
        </template>
    </dialog-modal>
</template>
<script setup>
import DialogModal from '@/Jetstream/DialogModal.vue';
import JetButton from '@/Jetstream/Button.vue';
import { eventBus, events } from '@/eventBus';
import { trans } from '@/mixins/i18n.js';
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue';

defineOptions({
    name: 'BlockedOperabilityChangeModal',
});

const shouldRender = ref(false);
const show = ref(false);
const workOrders = ref([]);

const onOpen = ({ workOrders: blockingWorkOrders }) => {
    workOrders.value = blockingWorkOrders ?? [];
    shouldRender.value = true;
    nextTick(() => (show.value = true));
};

function closeModal() {
    show.value = false;
    setTimeout(() => {
        shouldRender.value = false;
        workOrders.value = [];
    }, 300);

    // Revert the header's optimistic switch back to inoperable.
    eventBus.$emit(events.cancelConfirmAssetStatusChangeModal);
}

onMounted(() => {
    eventBus.$on(events.openBlockedOperabilityChangeModal, onOpen);
});

onBeforeUnmount(() => {
    eventBus.$off(events.openBlockedOperabilityChangeModal, onOpen);
});
</script>
